import { SHORTLIST_CONST } from '../actionConstants';
import {PATHS} from '../../AppConstants';
import { setApiLoading, setApiError,setApiSuccess } from './shortlistNShareActions';
import {getWishLists} from "../../UtilityComponents/cbTravelDeskUtil";
import {getAxiosConfig} from "../../apisSetup/apiConfig";
import { saveServerLogs, getCookie} from '../../UtilityComponents/Util';
import {ERROR_CONTENT, ERROR_HEADING, REMINDER_CONTENT, REMINDER_HEADING} from "../../shortListNShare/config";

const axiosApiCaller = getAxiosConfig(PATHS.WISHLIST_FQDN, true, {'Content-Type': 'application/json',
	'mmt-auth' : getCookie('mmt-auth')
}, false);

const PAGE_LOAD = 'PAGE_LOAD';

export const travelRequestListing = () => async dispatch => {
	try {
		dispatch(setApiLoading(PAGE_LOAD));
		const response = await axiosApiCaller.get(PATHS.TRAVEL_REQUEST_API);
		dispatch(setApiLoading(false))
		const responseData = getWishLists(response);
		if(responseData){
			dispatch({
				type: SHORTLIST_CONST.TRAVEL_REQUEST,
				payload: responseData
			})
		}
		else {
			dispatch(setApiError({
				name: PAGE_LOAD,
				data: {
					heading: ERROR_HEADING,
					content: ERROR_CONTENT
				}
			}));
		}
		dispatch({
			type: SHORTLIST_CONST.TRAVEL_REQUEST_CALLED,
		});
	} catch (e) {
		dispatch(setApiError({
			name: PAGE_LOAD,
		}));
		dispatch({
			type: SHORTLIST_CONST.TRAVEL_REQUEST_CALLED,
		});
		saveServerLogs(e.stack, 'error', PATHS.TRAVEL_REQUEST_API);
	}
}


export const filterResults = (value, filter) => dispatch  => {
	dispatch({
		type: SHORTLIST_CONST.FILTER_RESULTS,
		payload: {value, filter}
	})
}


export const remindEmployee = (wishListId) => async dispatch => {
	try {
		dispatch(setApiLoading(true));
		const response = await axiosApiCaller.get(`${PATHS.REMIND_EMPLOYEE}?wishlistId=${wishListId}`);
		dispatch(setApiLoading(false))
		const responseData = response && response.data;
		if(responseData && responseData.responseCode === '600'){
			dispatch(setApiSuccess({
				name: 'SUCCESS',
				isPopup: true,
				data: {
					heading: REMINDER_HEADING,
					content: REMINDER_CONTENT
				}
			}));
			return ;
		}
		dispatch(setApiError());
	} catch (e) {
		dispatch(setApiError());
		saveServerLogs(e.stack, 'error', PATHS.REMIND_EMPLOYEE);
	}
}
